<template>
    
      <b-card>
        <b-row>
          <div style="position:absolute; top:10px; right:25px;">
            <span style="display:inline-block" class="mr-2">
              <b-form-select v-model="salesPersonReqToSOConversionFilters.salesRep" @change="onGetSalesPersonReqToSOConversion" class="mb-2">
                <option :value="null"> -- All Sales Rep -- </option>
                <option v-for="(rep, i) in salesReps" :key="i" :value="rep.id">{{rep.name}} </option>
              </b-form-select>
            </span>
            <span style="display:inline-block">
              <b-form-select :value="salesPersonReqToSOSelectedDateRange" @change="onDateRangeChange" class="mb-2 mr-2">
                <option v-for="(type) in dateRangeTypes" :key="type" :value="type">  
                  {{type}}
                </option>
              </b-form-select> 
            </span>
          </div>
          <b-modal size="sm" title="Custom Date for Sales Person Req to SO Conversion" id="custom-date-sales-person-req-to-so-conversion" 
            @ok="onCustomSet" @cancel="$bvModal.hide('custom-date-sales-person-req-to-so-conversion')" no-close-on-backdrop>
            <div style="display:flex; flex-direction: row; justify-content: center; top: 0;">
              <!-- v-if="salesPersonMetricsSelectedDateRange === dateRangeTypes.CUSTOM" -->
            <b-form-group label="From" class="mb-4 mr-2" >
              <date-picker v-model="salesPersonReqToSOConversionFilters.dateFrom" :config="datePickerOptions" size="sm" />
            </b-form-group>
            <b-form-group label="To" class="mb-4">
              <date-picker v-model="salesPersonReqToSOConversionFilters.dateTo" :config="datePickerOptions" size="sm" />
            </b-form-group>
            </div>          
          </b-modal> 
          
        </b-row>
        <br/>
        <div>
          <apex-chart chartType="line" :chartOptions="chartOptions" :chartSeries="chartSeries" />
        </div>
      </b-card>  
</template>

<script>
  import ApexChart from './../extensions/ApexChart'
  import { ACTIVE, REQUEST_DATE, DATE_FORMAT, SEARCH_DEBOUNCE_TIME } from '@/shared/constants';
  import { getDatesFromRangeString, dateToDay, generateListofDates } from '@/shared/helpers';
  import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
  import { date } from '@/shared/filters';

  export default {
    components: {
      ApexChart
    },
    data () {
      return {
        dateRangeTypes: REQUEST_DATE,
        datePickerOptions: {
          format: DATE_FORMAT,
          useCurrent: false,
        },
        componentKey: 0,
        isLoadingWidget: true,
        salesBySalesRep: [],
        chartOptions: {},
        chartSeries: [],
      }
    },
    computed: {
      ...mapGetters('account', ['userId']),
      ...mapGetters('dashboard', ['salesPersonReqToSOSelectedDateRange', 'salesPersonReqToSOConversionFilters']),
      ...mapState('salesReps', ['salesReps'])
    }, 
    methods: {
      ...mapActions('dashboard', ['getSalesPersonReqToSOConversion']),
      ...mapMutations('dashboard', ['setItem']),
      onDateRangeChange(value) { 
        if (value === REQUEST_DATE.CUSTOM) {
          this.salesPersonReqToSOConversionFilters.dateFrom = null;
          this.salesPersonReqToSOConversionFilters.dateTo= null;
          this.$bvModal.show('custom-date-sales-person-req-to-so-conversion');
        } else {
          
          const { dateFrom, dateTo } = getDatesFromRangeString(value);
          this.setDefaults(dateFrom, dateTo);
          this.salesPersonReqToSOConversionFilters.dateFrom = dateFrom;
          this.salesPersonReqToSOConversionFilters.dateTo= dateTo;
          this.onGetSalesPersonReqToSOConversion();
        }

        this.setItem({ resource: 'salesPersonReqToSOSelectedDateRange', payload: value });
      },
      onCustomSet() {
        if (this.salesPersonReqToSOConversionFilters.dateFrom && this.salesPersonReqToSOConversionFilters.dateTo) {
          this.setDefaults(this.salesPersonReqToSOConversionFilters.dateFrom, this.salesPersonReqToSOConversionFilters.dateTo);
          this.onGetSalesPersonReqToSOConversion();
        }
        this.$bvModal.hide('custom-date-sales-person-req-to-so-conversion');
      },
      async onGetSalesPersonReqToSOConversion() {
        this.isLoadingWidget = true;

        await this.getSalesPersonReqToSOConversion(this.salesPersonReqToSOConversionFilters).then((res) => { 
          this.chartOptions = {
              ...this.chartOptions,
            noData: {
                text: (res.length > 0) ? '' : 'No available data'
            },
          }
          this.chartSeries = [
            {
                name: 'Requirements',
                data: res.map(val => ({
                  x: date(val.date),
                  y: val.reqCounts
                }))
            },
            {
                name: 'Quotes',
                data: res.map(val => ({
                  x: date(val.date),
                  y: val.quotCounts
                }))
            },
            {
                name: 'Sales Orders',
                data: res.map(val => ({
                  x: date(val.date),
                  y: val.soCounts
                }))
            }
          ]
          this.isLoadingWidget = false;
        });
      },
      setDefaults(from = null, to = null) {
          this.chartOptions = { 
            chart: {
                id: 'sales-person-req-to-so-conversion-chart',
                type: 'line',
                height: '250px'
            },
            title: {
                text: 'Sales Person Req to SO Conversion'
            },
            noData: {
                text: 'Fetching data...'
            },
            xaxis: {
              type: 'datetime'
            },
            dataLabels: {
              enabled: true
            }
          };
          this.chartSeries = [];
      }
    },
    mounted () {
      const { dateFrom, dateTo } = getDatesFromRangeString(this.salesPersonReqToSOSelectedDateRange);
      this.setDefaults(dateFrom, dateTo);
      this.salesPersonReqToSOConversionFilters.dateFrom = dateFrom;
      this.salesPersonReqToSOConversionFilters.dateTo = dateTo;
      this.onGetSalesPersonReqToSOConversion();   
    },
  }
</script>

<style>
  .small {
    max-width: 600px;
    margin:  150px auto;
  }
</style>